import './HeaderGenericPrimaryLeisure.css';
import React from 'react';
import { get, getColorByTheme, getPageThemeColors, getDictionaryItem } from '../../utils';
import { Text, Placeholder, RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import RouterLink from '../atoms/RouterLink';
import { canUseDOM } from '../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
const videoWhiteOverlayTime = 750;
const videoFadeTime = 400;
const HeaderGenericPrimaryLeisure = _ref => {
  let {
    rendering,
    fields,
    children,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const hasPageTitle = get(fields, 'Title');
  const hasPageIntro = get(fields, 'Intro Text');
  const ctaLink = get(fields, 'ctaLink.value.href');
  const ctaLabel = get(fields, 'ctaLabel.value');
  const ref = React.useRef();
  const refMedia = React.useRef();
  const refMediaWrap = React.useRef();
  const refMediaWrapInner = React.useRef();
  // const headerLarge: string = get(fields, 'Fallback image.value.src');
  const [isVdsite, setIsVdsite] = React.useState(true);
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ColorHex = get(params, 'ColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const introText = get(fields, 'Intro Text');
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const darkMode = get(sitecoreContext, 'darkMode');
  const actions = get(sitecoreContext, 'actions', {});
  const dictionary = get(fields, 'data.dictionary');
  const darkModeTitle = getDictionaryItem(dictionary, "dark mode") || '';
  const {
    changeThemeFunction = () => {}
  } = actions;
  const variables = BackgroundColorHex ? {
    "--m57-header-generic-primary-leisure-bg-color": BackgroundColorHex,
    "--m57-header-generic-primary-leisure-bg-active-color": ActiveColorHex,
    "--m57-header-generic-primary-leisure-color": ColorHex
  } : {
    "--m57-header-generic-primary-leisure-bg-color": primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary,
    "--m57-header-generic-primary-leisure-bg-active-color": primaryActivePageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary_active,
    "--m57-header-generic-primary-leisure-color": getColorByTheme(primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary)
  };
  const animationStart = () => {
    if (canUseDOM) {
      let mediaHeight;
      if (refMedia.current && refMediaWrapInner.current) {
        setTimeout(() => {
          mediaHeight = refMedia.current.clientHeight;
          refMediaWrap.current.style.height = `${mediaHeight}px`;
          refMediaWrapInner.current.style.height = `0px`;
        }, 10);
        setTimeout(() => {
          refMediaWrapInner.current.classList.add('header-media__wrap-inner--add-transition');
        }, 15);
        setTimeout(() => {
          ref.current.classList.add('info-anim-start');
          refMediaWrapInner.current.style.opacity = `1`;
          refMediaWrapInner.current.style.height = `${mediaHeight}px`;
        }, 50);
      }
      setTimeout(() => {
        ref.current && ref.current.classList.remove('anim-start');
        ref.current && ref.current.classList.remove('info-anim-start');
        refMediaWrap.current.style.height = `auto`;
        refMediaWrapInner.current.style.height = `auto`;
      }, 4000);
    }
  };
  if (!fields) {
    console.warn('HeaderGenericPrimary component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [HeaderGenericLegislation component is empty: please provide data source]");
    }
    return null;
  }
  const renderMediaPlaceholder = () => {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "dot-media-header-primary",
      rendering: rendering,
      mediaDesc: introText.value
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group remove-padding-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row header header-generic--primary anim-start",
    ref: ref
  }, /*#__PURE__*/React.createElement("button", {
    className: "header-animation-trigger",
    onClick: animationStart,
    tabIndex: -1
  }, ' ', "animation button"), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-media__wrap",
    ref: refMediaWrap
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-media__wrap-inner",
    ref: refMediaWrapInner
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-media remove-padding-header",
    ref: refMedia
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder()))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dark-mode-switcher-box item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1 col-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 col-7"
  }, params && params['Dark Mode Switcher Show'] && /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: darkModeTitle,
    value: darkMode,
    params: params
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 header-content__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: `header-content theme-contrast`
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-content__main header-animation__content"
  }, hasPageTitle && /*#__PURE__*/React.createElement(Text, {
    className: "h2 c-content__title",
    tag: "h1",
    field: hasPageTitle
  }), hasPageIntro && /*#__PURE__*/React.createElement(RichText, {
    className: "p c-content__text",
    tag: "div",
    field: hasPageIntro
  }), ctaLabel && ctaLink && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-secondary c-content__btn desktop__link ",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(params, {
        eventLab: ctaLabel
      }));
    },
    title: ctaLabel
  }, ctaLabel), /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLink,
    className: "btn btn-primary mob__link rs_skip",
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(params, {
        eventLab: ctaLabel
      }));
    },
    title: ctaLabel
  }, ctaLabel))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  })))))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `header-animation ${commonStyles} ${fullWidthStyles} ${rtl ? rtlStyles : ltrStyles} ${headerImageStyle}`,
    removePaddingHeader: true,
    componentTabIndex: "disabled"
  }, children);
};
export const commonStyles = "c1eh0o24";
export const ltrStyles = "l1qhu04c";
export const rtlStyles = "r11ix7xt";
export default HeaderGenericPrimaryLeisure;